import MapWithAMarkerClusterer from './MapWithAMarkerClusterer';

export default MapWithAMarkerClusterer;
